import axios from "axios";

const Url = process.env.REACT_APP_URl;
const UrlDev = process.env.REACT_APP_URl;


export const GenerateCaptionsServ = async (images: any) => {
    const apiUrl = Url + "/generatecaption";
    const response = await axios.post(apiUrl, images, {
        headers : {   
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}

export const ListingVideoServ = async (listings: any) => {
    const apiUrl = UrlDev + "/generate_videov2";
    const response = await axios.post(apiUrl, listings, {
        headers : {   
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response;
}


export const FetchDownloadLink = async (src: string) => {
    const apiUrl = Url + "/fetch_download_link";
    const response = await axios.post(apiUrl, { "src": src }, {
        headers : {   
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}


export const RecentVideosService = async (page: number) => {
    const apiUrl = UrlDev + "/uservideos";
    const response = await axios.post(apiUrl, {
        "page": page,
        "limit": 10
    }, {
        headers : {   
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}

export const DeleteRecentVideosService = async (id: any) => {
    const apiUrl = UrlDev + "/videos/";
    const response = await axios.delete(`${apiUrl}${id}`, {
        headers : {   
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}